let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Aowi")).then(() => parcelRequire('bAKRr'));